import { Component, defineComponent, onMounted } from 'vue';

import Faq from './Faq.class';
import FaqItem from './FaqItem.vue';

export default defineComponent({
	components: {
		FaqItem: FaqItem as Component
	},
	setup: () => {
		const component = new Faq();

		onMounted(component.mounted.bind(component));

		return {
			faqs: component.faqs,
			isFaqsEmpty: component.isFaqsEmpty
		};
	}
});
